var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"fit-content"}},[_c('b-table',{attrs:{"thead-class":"text-nowrap thead-class","items":_vm.items,"fields":_vm.fields,"responsive":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }